
































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import DeleteSMSMessage from "./deletesmsmessage.vue";
import SearchTree from "@/lib/Common/searchtree";

class PageLogsRequest extends PageRequest {
    keyword: string;
    areaId: number;
    operationType: number;
    startTime: string;
    endTime: string;
}

@Component({
    components: { DeleteSMSMessage },
})
export default class SMSMessage extends AbpBase {
    //批量删除
    batchdel() {
        this.deleModalShow = true;
    }
    //filters
    pagerequest: PageLogsRequest = new PageLogsRequest();
    areaTree: any[] = [];
    areaTreeList: any[] = [];
    searchName: string = "";
    deleModalShow: boolean = false;
    viewModalShow: boolean = false;
    splitnum: number = 0.15;

    changeSort(key) {
        if (key.order !== "normal") {
            this.pagerequest.sorting = key.key + " " + key.order;
        }
        this.getpage();
    }
    get list() {
        return this.$store.state.smsmessage.list;
    }
    get loading() {
        return this.$store.state.smsmessage.loading;
    }
    isActiveChange(val: number) {
        this.$store.commit("smsmessage/setCurrentPage", 1);
        this.getpage();
    }
    getItemId() {
        let item = (this.$refs.tree as any).getSelectedNodes();
        if (item.length > 0) {
            this.pagerequest.areaId = item[0].id;
        }
        this.$store.commit("smsmessage/setCurrentPage", 1);
        this.getpage();
    }
    pageChange(page: number) {
        this.$store.commit("smsmessage/setCurrentPage", page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("smsmessage/setPageSize", pagesize);
        this.getpage();
    }
    getDetail() {
        if (localStorage.getItem("itemdetail") === null) {
            this.$store.dispatch({
                type: "itemdetail/getdetailtolocalstorge",
            });
        }
        let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
        if (detaillist.length > 0) {
            let info = detaillist.filter((p) => {
                return p.itemId == 18 || p.itemId == 19 || p.itemId == 20;
            });
            info.forEach((ele) => {
                this.$data.messagetype.push({
                    label: ele.name,
                    value: ele.id,
                });
            });
            let devicet = detaillist.filter((p) => {
                return p.itemId == 7;
            });
            devicet.forEach((ele) => {
                this.$data.devicetype.push({
                    label: ele.name,
                    value: ele.id,
                });
            });
        }
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        if (this.pagerequest.startTime == null) {
            this.pagerequest.startTime = Moment()
                .startOf("day")
                .format("YYYY-MM-DD HH:mm:ss");
        }
        if (this.pagerequest.endTime == null) {
            this.pagerequest.endTime = Moment()
                .endOf("day")
                .format("YYYY-MM-DD HH:mm:ss");
        }
        await this.$store.dispatch({
            type: "smsmessage/getAll",
            data: this.pagerequest,
        });
    }
    get pageSize() {
        return this.$store.state.smsmessage.pageSize;
    }
    get totalCount() {
        return this.$store.state.smsmessage.totalCount;
    }
    get currentPage() {
        return this.$store.state.smsmessage.currentPage;
    }
    columns = [
        {
            type: "index",
            width: 60,
            align: "left",
            title: this.L("IndexNo"),
            fixed: "left",
        },
        {
            title: this.L("Organizations"),
            key: "organizationId",
            width: 130,
            render: (h: any, params: any) => {
                let id = params.row.organizationId;
                let ite = JSON.parse(localStorage.getItem("organizations"));
                let info = ite.filter((p) => {
                    return p.id == id;
                });
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: {
                                title:
                                    info.length > 0 ? info[0].displayName : this.L("Unknown"),
                            },
                        },
                        info.length > 0 ? info[0].displayName : this.L("Unknown")
                    ),
                ]);
            },
        },
        {
            title: this.L("Areas"),
            key: "areaId",
            sortable: true,
            width: 130,
            render: (h: any, params: any) => {
                let id = params.row.areaId;
                let ite = JSON.parse(localStorage.getItem("areas"));
                let info = ite.filter((p) => {
                    return p.id == id;
                });
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: {
                                title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
                            },
                        },
                        info.length > 0 ? info[0].fullName : this.L("Unknown")
                    ),
                ]);
            },
        },
        {
            title: this.L("Title"),
            key: "title",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.title,
                        },
                    },
                    params.row.title
                );
            },
        },
        {
            title: this.L("Content"),
            key: "content",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.content,
                        },
                    },
                    params.row.content
                );
            },
        },
        {
            title: this.L("Mobile"),
            key: "mobile",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.mobile,
                        },
                    },
                    params.row.mobile
                );
            },
        },
        {
            sortable: true,
            title: this.L("SnedTime"),
            key: "sendTime",
            width: 150,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.sendTime == null
                        ? ""
                        : Moment(params.row.sendTime).format("YYYY-MM-DD HH:mm:ss")
                );
            },
        },
        {
            title: this.L("SendResult"),
            key: "sendResult",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.sendResult,
                        },
                    },
                    params.row.sendResult
                );
            },
        },
        {
            title: this.L("ResultCode"),
            key: "resultCode",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.resultCode,
                        },
                    },
                    params.row.resultCode
                );
            },
        },
        {
            title: this.L("ResultDesc"),
            key: "resultDesc",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.resultDesc,
                        },
                    },
                    params.row.resultDesc
                );
            },
        },
        {
            title: this.L("FromSource"),
            key: "source",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.source,
                        },
                    },
                    params.row.source
                );
            },
        },
        {
            title: this.L("Total"),
            key: "total",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.total,
                        },
                    },
                    params.row.total
                );
            },
        },
        {
            title: this.L("Id"),
            key: "messageId",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.messageId,
                        },
                    },
                    params.row.messageId
                );
            },
        },
        {
            title: this.L("Actions"),
            key: "Actions",
            width: 150,
            fixed: "right",
            render: (h: any, params: any) => {
                return h("div", [

                    h(
                        "Button",
                        {
                            props: {
                                type: "error",
                                size: "small",
                            },
                            on: {
                                click: async () => {
                                    this.$Modal.confirm({
                                        title: this.L("Tips"),
                                        content: this.L("DeleteConfirm"),
                                        okText: this.L("Yes"),
                                        cancelText: this.L("No"),
                                        onOk: async () => {
                                            await this.$store.dispatch({
                                                type: "smsmessage/delete",
                                                data: params.row,
                                            });
                                            await this.getpage();
                                        },
                                    });
                                },
                            },
                        },
                        this.L("Delete")
                    ),
                ]);
            },
        },
    ];
    async created() {
        this.pagerequest.startTime = Moment()
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
        this.pagerequest.endTime = Moment()
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
        this.getAreaTree();
        this.getDetail();
        this.getpage();
    }
    //搜索树形结构
    searchTree(value: any, treeList) {
        if (!value) {
            this.areaTree = this.areaTreeList;
            return;
        }
        this.areaTree = SearchTree.searnchTree(value, treeList);
    }
    //区域
    async getAreaTree() {
        await this.$store
            .dispatch("area/getAreaLeftTree")
            .then((val) => {
                this.areaTree = val;
                this.areaTreeList = val;
            })
            .catch((err) => {
                //return null;
            });
    }
    // 时间触发
    changeTime(time) {
        this.pagerequest.startTime = Moment(time[0], "YYYY-MM-DD HH:mm:ss")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
        this.pagerequest.endTime = Moment(time[1])
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
        this.getpage();
        //console.log(this.pagerequest)
    }
    data() {
        return {
            messagetype: [], //信息类型
            devicetype: [], //设备类型
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
            options2: {
                shortcuts: [
                    {
                        text: this.L("OneWeek"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("OneMonth"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("ThreeMonths"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            return [start, end];
                        },
                    },
                ],
            },
        };
    }
}
